import * as React from 'react';
import TenKFilings from './financials/TenKFilings';
import EightKFilings from './financials/EightKFilings';
import TenQFilings from './financials/TenQFilings';
import ProxyStatements from './financials/ProxyStatements';

function SecFilings({data} :any) {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/sec_filings">SEC Filings</a></li>
            <li className="breadcrumb-item"><a href={"/ticker/" + data?.company} >{data?.company}</a></li>
            <li className="breadcrumb-item active" aria-current="page">{data?.company} SEC Filings</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <TenKFilings filings={data} />
        <TenQFilings filings={data} />
        <EightKFilings filings={data} />
        <ProxyStatements filings={data} />
      </div>
    </div>
  );
}

export default SecFilings;
